import { render, staticRenderFns } from "./wangguan.vue?vue&type=template&id=604ed594&scoped=true&"
import script from "./wangguan.vue?vue&type=script&lang=js&"
export * from "./wangguan.vue?vue&type=script&lang=js&"
import style0 from "./wangguan.vue?vue&type=style&index=0&id=604ed594&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604ed594",
  null
  
)

export default component.exports